/* ==========================================================================
   MAISON REVØRA — Kollektion · Merkliste · Suche   (Präfix .rvc-) — Shopify-Theme (16.10.2026)
   Aus dem Vorschau-Prototyp (src/page-collection.js) übernommen. Seiten: collection · merkliste · suche
   (sections/rvm-collection.liquid, sections/rvm-search.liquid). Daten kommen kompakt aus
   <script data-rvc-data> und werden hier ins RV-Format gebracht; Links/Filter-Zustand = echte URLs.
   Raster immer mit Farbregel (Farbfamilien wie RV.fam, positionsgenau inkl.
   Editorial-Kacheln, mit der tatsächlich sichtbaren Spaltenzahl), Filter als
   Drawer, Mehr laden bis Reihenende, Restzellen der letzten Reihe als Kachel.
   ========================================================================== */
(function () {
  "use strict";
  const D = RV.D, $ = RV.$, esc = RV.esc;
  const EN = /^en/i.test((RV.cfg && RV.cfg.locale) || "");
  const T = (de, en) => (EN ? en : de);
  const STEP = 24;
  const MQ_M = window.matchMedia("(max-width:760px)");
  const MQ_T = window.matchMedia("(max-width:1100px)");
  const REDUCE = window.matchMedia("(prefers-reduced-motion: reduce)");
  const it = (s) => `<span class="rv-it">${s}</span>`;
  const fam = (n) => (RV.fam ? RV.fam(n) : n);
  /* Breakpoint: m ≤760 · t ≤1100 · d */
  const bp = () => (MQ_M.matches ? "m" : MQ_T.matches ? "t" : "d");
  const vpCols = () => ({ m: 2, t: 3, d: 4 })[bp()];
  const onBP = (fn) => { MQ_M.addEventListener("change", fn); MQ_T.addEventListener("change", fn); return () => { MQ_M.removeEventListener("change", fn); MQ_T.removeEventListener("change", fn); }; };
  /* Wörter mit Bindestrich nie am Strich umbrechen (ohne Sonderglyphe, die der Bodoni fehlen könnte) */
  const keep = (s) => esc(s).replace(/(\S+-\S+)/g, '<span class="rv-nb">$1</span>');

  /* ---------- Daten: kompaktes Section-JSON -> RV-Format ---------- */
  const TILE_COLORS = {};
  /* c: Farbname fürs Hover-Bild (Rückansicht) — RV.norm ordnet Bilder über " in <Farbe>," zu */
  function decode(x, pf) {
    const full = (u) => (!u ? "" : /^(https?:)?\/\//.test(u) ? u : pf + u);
    const im = [];
    (x.g || []).forEach(([u, w, h, a, hu, c]) => {
      im.push([full(u), w, h, a]);
      if (hu) im.push([full(hu), 0, 0, " in " + c + ", Rückansicht"]);
    });
    const o1 = (x.ov || [])[0] || [], o2 = (x.ov || [])[1] || [], fv = x.v || [], v = [];
    for (let i = 0, j = 0; i + 2 < fv.length; i += 3, j++) v.push([0, o1[fv[i]] == null ? "" : o1[fv[i]], o2[fv[i + 1]] == null ? "" : o2[fv[i + 1]], x.pr ? x.pr[j] : x.p, 0, fv[i + 2]]);
    return { h: x.h, t: x.t, ty: x.ty, tg: x.tg || [], cr: x.cr, o: x.o || [], ov: x.ov || [], im, v, col: [], p: x.p, cp: x.cp || 0 };
  }
  /* Produkte aufnehmen; schon vorhandene (z. B. volle Daten aus /products/h.js) nie überschreiben */
  function ingest(d, opt = {}) {
    if (!d) return [];
    /* vorhandene volle Daten bleiben; schlanke (Mega-Menü) werden durch die kompakten mit Varianten ersetzt */
    const add = (d.pl || []).filter((x) => x && x.h && (!RV.prod(x.h) || RV.prod(x.h).slim)).map((x) => decode(x, d.pf || ""));
    RV.addProducts(add);
    if (opt.slim) add.forEach((x) => { const p = RV.prod(x.h); if (p) p.slim = true; }); /* ohne Varianten-IDs: bei Bedarf neu laden */
    const cs = (d.cs || []).filter((c) => !RV.coll(c.h));
    if (d.c && d.c.h) cs.unshift(Object.assign({}, d.c, { p: (d.pl || []).map((x) => x.h) }));
    RV.addCollections(cs);
    Object.assign(TILE_COLORS, d.tile || {});
    return (d.pl || []).map((x) => x.h);
  }
  let DATA = null;
  const data = () => {
    if (DATA) return DATA;
    const s = document.querySelector('script[type="application/json"][data-rvc-data]');
    try { DATA = s ? JSON.parse(s.textContent) : {}; } catch (e) { console.error("rvc-data", e); DATA = {}; }
    return DATA;
  };
  /* Anzahl Teile einer Kollektion: geladene Liste, sonst Zahl aus Liquid */
  const cnt = (h) => { const c = RV.coll(h); if (!c) return 0; return c.p && c.p.length ? RV.collProducts(h).length : c.n || 0; };
  const dec = (s) => { const t = document.createElement("textarea"); t.innerHTML = String(s || ""); return t.value; };

  /* ---------- Kuratierung ---------- */
  const BANNER = { winter: "winter", "azur-club": "azur", riviera: "riviera", "t-shirts": "shirts" };
  const HERO = {
    winter: { t: '<span class="rvc-kw">W</span>inter', tag: "Hiver au Sud", lead: T("Warme Teile mit Motiven aus dem Süden – vorne ein kleines RØ.", "Warm pieces with motifs from the South – a small RØ on the front.") },
    "azur-club": { t: "Azur " + it("Club"), tag: T("Die laute Seite von REVØRA", "The loud side of REVØRA"), lead: T("Statement-Shirts mit großem Rückenprint – Clubs, Cocktails und eine Portion Selbstironie.", "Statement shirts with a large back print – clubs, cocktails and a dose of self-irony.") },
    riviera: { t: "Riviera", tag: T("Zitronen, Wellen und Aperitivo", "Lemons, waves and aperitivo"), lead: T("Küstensommer und Süditalien, groß auf dem Rücken getragen.", "Coastal summer and southern Italy, worn large on the back.") },
    "t-shirts": { t: T("Alle " + it("Shirts"), "All " + it("shirts")), tag: "Azur Club &amp; Riviera", lead: T("Jedes Shirt oversized und unisex geschnitten – das Motiv sitzt groß auf dem Rücken.", "Every shirt is cut oversized and unisex – the motif sits large on the back.") },
  };
  const TITLE = {
    "neu-eingetroffen": T("Neu " + it("eingetroffen"), "New " + it("arrivals")),
    "fuer-sie": T("Für " + it("Sie"), "For " + it("her")),
    "fuer-ihn": T("Für " + it("Ihn"), "For " + it("him")),
    all: T("Alle " + it("Teile"), "All " + it("pieces")),
    "geschenke-unter-50": T("Geschenke " + it("unter 50&nbsp;€"), "Gifts " + it("under €50")),
  };
  /* eigene Leads statt Live-Text: [Lead, Mehr-lesen-Text] */
  const LEAD = { "neu-eingetroffen": [T("Die zuletzt erschienenen Motive – jedes Teil wird nach deiner Bestellung in Deutschland bedruckt.", "The latest motifs – every piece is printed in Germany after you order."), ""] };
  /* Unterkollektionen als Chips (Für Sie/Für Ihn bewusst nicht: größer als die Eltern-Kollektion) */
  const FAM = [
    ["t-shirts", "azur-club", "riviera"],
    ["hoodies", "zip-hoodies", "sweatshirts", "longsleeves"],
    ["jacken", "jogger", "accessoires"],
  ];
  const CHIP_T = { "t-shirts": T("Alle Shirts", "All shirts") };
  const TYPE = { "Unisex-Shirts": "Oversized Shirts", "Open-Hem-Jogger": "Jogger" };
  const TYPE_ORDER = ["Oversized Shirts", "Hoodies", "Zip-Hoodies", "Sweatshirts", "Longsleeves", "Jacken", "Fleecejacken", "Jogger", "Caps"];
  const TYPE_EN = { Jacken: "Jackets", Fleecejacken: "Fleece jackets" };
  const typeLabel = (k) => (EN && TYPE_EN[k]) || k;
  const COLOR_ORDER = ["Black", "White", "Off White", "Natural Raw", "Heather Grey", "French Navy", "Union Beige", "Beige", "Desert Sand"];
  const ONE = "Einheitsgröße";
  const sizeLabel = (s) => (s === ONE ? T(ONE, "One size") : s);
  const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL", "3XL", ONE];
  const SORTS = [["empf", T("Empfohlen", "Recommended")], ["neu", T("Neueste zuerst", "Newest first")], ["pa", T("Preis aufsteigend", "Price: low to high")], ["pd", T("Preis absteigend", "Price: high to low")]];
  const typeKey = (p) => TYPE[p.ty] || p.ty;
  const ord = (arr, x) => { const i = arr.indexOf(x); return i < 0 ? 99 : i; };
  const teile = (n) => (EN ? `${n} ${n === 1 ? "piece" : "pieces"}` : `${n} ${n === 1 ? "Teil" : "Teile"}`);
  /* Live-Text säubern; der falsche Versandsatz (Österreich fehlt) wird in der Anzeige korrigiert */
  const clean = (s) => dec(s).replace(/\s+/g, " ")
    .replace(/Versand nach Deutschland und in die Schweiz kostenlos\./g, "Kostenloser Standardversand nach DE · CH.").trim();
  const split1 = (s) => { const m = s.match(/^(.+?[.!?])\s+(\S.*)$/); return m ? [m[1], m[2]] : [s, ""]; };

  /* ---------- Icons (seiteneigen) ---------- */
  const ICO = {
    filter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M3 7h10M17 7h4M3 17h4M11 17h10"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></svg>',
    cols(n) {
      const g = 2, w = (20 - (n - 1) * g) / n;
      let r = "";
      for (let i = 0; i < n; i++) r += `<rect x="${(2 + i * (w + g)).toFixed(2)}" y="${n === 1 ? 3 : 5}" width="${w.toFixed(2)}" height="${n === 1 ? 18 : 14}" rx=".6"/>`;
      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true">${r}</svg>`;
    },
  };

  /* ---------- Editorial-Kacheln (Farbe = für die Farbregel) ---------- */
  const B = D.banner || {};
  /* Motiv-Kachel verlinkt aufs Produkt in dieser Farbe, wenn es die Farbe gibt (geladen oder laut Liquid) */
  const prodHref = (h, col, fb) => {
    const p = RV.prod(h);
    const has = p ? p.c.some((c) => c.n === col) : (TILE_COLORS[h] || []).includes(col);
    return has ? RV.href.p(h, col) : fb;
  };
  const KI = T("KI-generierte Abbildung", "AI-generated image");
  const TILE = {
    canvas: { kind: "canvas", color: "French Navy", html: () => `
      ${RV.crest()}
      <div class="rv-eyebrow">Maison REVØRA</div>
      <p class="rv-h2 rvc-tile__h">${T("Ein Teil.<br>" + it("Für dich bedruckt."), "One piece.<br>" + it("Printed for you."))}</p>
      <p class="rvc-tile__s">${esc(D.fakten.druck)}.</p>
      <a class="rv-link" href="${RV.href.maison()}">${T("Die Maison", "The Maison")}</a>` },
    canvasWinter: { kind: "canvas", color: "French Navy", html: () => `
      ${RV.crest("HIVER AU SUD · MAISON REVØRA · MMXXVI · ")}
      <div class="rv-eyebrow">Hiver au Sud</div>
      <p class="rv-h2 rvc-tile__h">${T("Wärme,<br>" + it("im Süden gedacht."), "Warmth,<br>" + it("imagined in the South."))}</p>
      <p class="rvc-tile__s">${T("Hoodies, Zip-Hoodies und Sweatshirts mit großem Motiv auf dem Rücken – vorne ein kleines RØ.", "Hoodies, zip hoodies and sweatshirts with a large motif on the back – a small RØ on the front.")}</p>
      <a class="rv-link" href="${RV.href.c("hoodies")}">${T("Alle Hoodies", "All hoodies")}</a>` },
    canvasPaper: { kind: "paper", color: "White", html: () => `
      <div class="rvc-tile__mono">${RV.monoSVG("currentColor", 1.6)}</div>
      <div class="rv-eyebrow">Le Club</div>
      <p class="rv-h2 rvc-tile__h">${T("Kostenloser Versand<br>" + it("nach DE · CH"), "Free shipping<br>" + it("to DE · CH"))}</p>
      <p class="rvc-tile__s">${esc(D.fakten.lieferzeit)}.</p>
      <a class="rv-link" href="${RV.href.seite("versand-lieferung")}">${T("Versand &amp; Lieferung", "Shipping &amp; delivery")}</a>` },
    aperitivo: { kind: "img", b: "aperitivo", color: "Black", eb: "Azur Club · Aperitivo", t: "Cin " + it("Cin"), href: () => prodHref("cin-cin", "Black", RV.href.c("azur-club")), cta: T("Zum Motiv", "View the motif") },
    terrasse: { kind: "img", b: "terrasse", color: "French Navy", eb: "Riviera · Terrasse", t: "La Dolce " + it("Vita"), href: () => prodHref("la-dolce-vita-pomegranate", "French Navy", RV.href.c("riviera")), cta: T("Zum Motiv", "View the motif") },
    beach: { kind: "img", b: "beach", color: "Heather Grey", eb: "Riviera · Plage", t: "Life comes " + it("in waves"), href: () => prodHref("life-comes-in-waves", "Heather Grey", RV.href.c("riviera")), cta: T("Zum Motiv", "View the motif") },
  };
  const TILES = { winter: ["canvasWinter", "canvasPaper"], "azur-club": ["aperitivo", "canvas"], riviera: ["terrasse", "beach"], "t-shirts": ["beach", "canvas"], _: ["canvas", "terrasse"] };
  /* Kacheln, die die Restzellen der letzten Reihe füllen dürfen (ruhige Text-Kacheln zuerst) */
  const FILL = ["canvasPaper", "canvas"];

  /* ---------- Raster-Layout + Farbregel ---------- */
  function layout(n, cols, tiles, filler) {
    const span = Math.min(2, cols), want = [];
    if (tiles[0] && n >= Math.max(12, 3 * cols)) want.push({ id: tiles[0], r: 2, c: 0 });
    if (tiles[1] && n >= Math.max(30, 8 * cols)) want.push({ id: tiles[1], r: 7, c: cols - span });
    const items = [];
    let r = 0, c = 0, pi = 0;
    const adv = (w) => { c += w; if (c >= cols) { r++; c = 0; } };
    while (pi < n) {
      const t = want.find((t) => !t.done && t.r === r && t.c === c);
      if (t) { t.done = true; items.push({ t: "tile", id: t.id, r, c, span, before: pi }); adv(span); continue; }
      items.push({ t: "p", i: pi, r, c }); pi++; adv(1);
    }
    /* letzte Reihe nie halb leer: Restzellen als eine Kachel */
    if (c > 0 && n > 0 && filler) items.push({ t: "tile", id: filler, r, c, span: cols - c, before: n, end: true });
    return items;
  }
  /* Farbregel positionsgenau nach Farbfamilie: links/oben/rechts/unten (inkl. Kacheln) nie gleich.
     Geht das mit dem nächsten Teil nicht (z. B. zwei einfarbige Jacken hintereinander),
     rückt ein passendes Teil aus den nächsten 8 vor (bei Preis-Sortierung nur gleicher Preis).
     Danach ruhige Abwechslung: Diagonale + letzte Karten meiden, sonst Hauptfarbe. */
  function arrange(list, items, allowed, same, mc) {
    const at = {}, seq = [], order = [], ci = [], rest = list.slice();
    let bad = 0;
    const k = (r, c) => r + "," + c;
    const f = (p, i) => fam(p.c[i].n);
    items.forEach((x) => { if (x.t === "tile") for (let j = 0; j < x.span; j++) at[k(x.r, x.c + j)] = fam(TILE[x.id].color); });
    const cands = (p) => { const c = p.c.map((_, i) => i).filter((i) => !allowed || allowed.has(p.c[i].n)); return c.length ? c : p.c.map((_, i) => i); };
    items.forEach((x) => {
      if (x.t !== "p") return;
      const left = at[k(x.r, x.c - 1)], up = at[k(x.r - 1, x.c)], right = at[k(x.r, x.c + 1)], down = at[k(x.r + 1, x.c)];
      const hard = [left, up, right, down].filter(Boolean);
      const dia = [at[k(x.r - 1, x.c - 1)], at[k(x.r - 1, x.c + 1)]];
      let pick = -1, pool = null;
      for (let j = 0; j < Math.min(8, rest.length); j++) {
        if (j && same && !same(rest[0], rest[j])) break;
        const pl = cands(rest[j]).filter((i) => !hard.includes(f(rest[j], i)));
        /* mc: unter den passenden das am stärksten eingeschränkte Teil zuerst (wenige Farben) */
        if (pl.length && (!mc || pick < 0 || pl.length < pool.length)) { pick = j; pool = pl; if (!mc) break; }
      }
      if (pick < 0) {
        pick = 0; bad++;
        const c0 = cands(rest[0]);
        pool = c0.filter((i) => ![left, right].includes(f(rest[0], i)));
        if (!pool.length) pool = [c0[0]];
      }
      const p = rest.splice(pick, 1)[0];
      const recent = seq.slice(-4);
      const score = (i, r) => dia.filter((d) => d === f(p, i)).length * 2 + recent.filter((n) => n === f(p, i)).length + r * 0.35;
      const c = pool.map((i, r) => [i, score(i, r)]).sort((a, b) => a[1] - b[1])[0][0];
      at[k(x.r, x.c)] = f(p, c);
      seq.push(f(p, c));
      order[x.i] = p; ci[x.i] = c;
    });
    return { order, ci, bad };
  }
  /* bestes Raster: normale Reihenfolge, sonst eingeschränkte Teile vorziehen; Restkachel so wählen, dass nichts kollidiert */
  function best(list, cols, tiles, fillers, allowed, same) {
    let top = null;
    for (const fl of fillers.length ? fillers.slice(0, 3) : [null]) {
      const items = layout(list.length, cols, tiles, fl);
      for (const mc of [false, true]) {
        const ar = arrange(list, items, allowed, same, mc);
        if (!top || ar.bad < top.ar.bad) top = { items, ar };
        if (!ar.bad) return top;
      }
    }
    return top;
  }

  function tileHTML(id, span, cols) {
    const T_ = TILE[id];
    const tall = MQ_M.matches && span >= cols;
    let inner;
    if (T_.kind === "img") {
      const b = B[T_.b] || {};
      inner = `<a class="rvc-tile__fill" href="${T_.href()}">
        <picture>${b.m ? `<source media="(max-width:760px)" srcset="${RV.srcset(b.m, [480, 720, 960])}" sizes="100vw">` : ""}
        ${RV.imgTag(b.d, { w: 1200, sizes: `(max-width:760px) 100vw, ${Math.round((100 * span) / cols)}vw`, alt: "", ws: [720, 960, 1200, 1600, 2000] })}</picture>
        <span class="rvc-tile__shade"></span>
        <span class="rvc-tile__cap"><span class="rv-eyebrow">${esc(T_.eb)}</span><span class="rv-h2 rvc-tile__h">${T_.t}</span><span class="rv-link">${esc(T_.cta)}</span></span>
        <span class="rvc-ki">${KI}</span></a>`;
    } else {
      inner = `<div class="rvc-tile__fill ${T_.kind === "paper" ? "rv-canvas rv-canvas--paper" : "rv-canvas"}"><div class="rvc-tile__c">${T_.html()}</div></div>`;
    }
    return `<div class="rvc-tile rvc-tile--${T_.kind}${tall ? " rvc-tile--tall" : ""}${span === 1 ? " rvc-tile--one" : ""}" style="--span:${span}" data-c="${esc(T_.color)}" data-reveal="fade"><div class="rvc-tile__box">${inner}</div></div>`;
  }

  /* kleine Vorschlags-Raster (Neu eingetroffen …): Spaltenzahl = sichtbare Spalten, volle Reihen */
  const miniHTML = (h, want) => {
    const gc = vpCols(), n = Math.max(gc, Math.floor(want / gc) * gc);
    return RV.grid(RV.collProducts(h).slice(0, n), { cols: gc, reveal: true, badge: false, sizes: "(max-width:760px) 50vw, (max-width:1100px) 33vw, 25vw" });
  };
  const paintMini = (root) => {
    root.querySelectorAll("[data-mini]").forEach((g) => { const [h, n] = g.dataset.mini.split(":"); g.innerHTML = miniHTML(h, +n); });
    RV.reveal(root); RV.wish.sync();
  };
  const miniGrid = (h, want) => `<div class="rv-grid" data-mini="${h}:${want}">${miniHTML(h, want)}</div>`;

  /* ---------- Lister: Werkzeugleiste + Filter-Drawer + Raster + Mehr laden ---------- */
  function createLister(opt) {
    const uid = "rvc" + Math.random().toString(36).slice(2, 7);
    const S = { k: new Set(), f: new Set(), g: new Set(), sort: "empf", shown: STEP };
    const q = opt.query || {};
    const csv = (v) => String(v || "").split(",").map((s) => s.trim()).filter(Boolean);
    csv(q.k).forEach((x) => S.k.add(x)); csv(q.f).forEach((x) => S.f.add(x)); csv(q.g).forEach((x) => S.g.add(x));
    if (SORTS.some(([v]) => v === q.sort)) S.sort = q.sort;
    let all = opt.products.slice(), pos = new Map(all.map((p, i) => [p.h, i]));
    let root, bar, grid, more, act, drawer, list = [], items = [], ci = [], shownItems = 0, rendered = 0, lastTop = -1, cols = 0;
    const showCount = opt.count !== false;
    const densOn = () => !opt.small && all.length > (opt.densMin || 0);
    /* NEU nur, wenn es etwas unterscheidet: weniger als die Hälfte der Liste ist neu */
    const badgeOn = () => opt.badge !== false && all.length > 0 && all.filter((p) => p.neu).length / all.length < 0.5;

    const colsOpts = () => (bp() === "m" ? [1, 2] : bp() === "t" ? [2, 3] : [2, 3, 4]);
    /* ohne eigene Wahl: Spaltenzahl so, dass keine Waisen entstehen (9 → 3 Spalten), kleine Listen als Feature */
    const autoCols = (n) => {
      const b = bp(), max = vpCols();
      if (b === "m") return 2;
      if (n > 0 && n <= 3) return Math.min(max, n + 1);
      if (n <= 9 && n % max !== 0 && n % (max - 1) === 0) return max - 1;
      return max;
    };
    const getCols = (n) => {
      if (opt.small) return autoCols(n);
      const pref = RV.store.get("rvc_cols", {})[bp()];
      return colsOpts().includes(pref) ? pref : autoCols(n);
    };
    const setCols = (n) => { const o = RV.store.get("rvc_cols", {}); o[bp()] = n; RV.store.set("rvc_cols", o); };

    /* Filter-Logik */
    const sizeOk = (p, st) => {
      const colOk = (v) => !st.f.size || st.f.has((p.c[v[1]] || {}).n);
      if (!p.s.length) return st.g.has(ONE) && p.v.some((v) => v[5] && colOk(v));
      return p.v.some((v) => v[5] && st.g.has(p.s[v[2]]) && colOk(v));
    };
    const match = (p, st) =>
      (!st.k.size || st.k.has(typeKey(p))) && (!st.f.size || p.c.some((c) => st.f.has(c.n))) && (!st.g.size || sizeOk(p, st));
    const filtered = (st = S) => all.filter((p) => match(p, st));
    const sorted = (l) => {
      const o = l.slice(), ix = (p) => pos.get(p.h);
      if (S.sort === "neu") o.sort((a, b) => (b.created || "").localeCompare(a.created || "") || ix(a) - ix(b));
      else if (S.sort === "pa") o.sort((a, b) => a.p - b.p || ix(a) - ix(b));
      else if (S.sort === "pd") o.sort((a, b) => b.p - a.p || ix(a) - ix(b));
      return o;
    };
    const facetCount = (fk, val) => filtered({ ...S, [fk]: new Set([val]) }).length;
    const nActive = () => S.k.size + S.f.size + S.g.size;
    /* Kacheln nie in einer gefilterten Farbe(nfamilie) */
    const tileOk = (id) => !S.f.size || ![...S.f].map(fam).includes(fam(TILE[id].color));

    /* Facetten aus allen Teilen der Liste */
    const facets = () => {
      const t = new Map(), c = new Map(), s = new Set();
      all.forEach((p) => {
        t.set(typeKey(p), (t.get(typeKey(p)) || 0) + 1);
        p.c.forEach((x) => c.set(x.n, x.x));
        if (!p.s.length) s.add(ONE); else p.s.forEach((x) => s.add(x));
      });
      return {
        k: [...t.keys()].sort((a, b) => ord(TYPE_ORDER, a) - ord(TYPE_ORDER, b)),
        f: [...c.entries()].sort((a, b) => ord(COLOR_ORDER, a[0]) - ord(COLOR_ORDER, b[0])),
        g: [...s].sort((a, b) => ord(SIZE_ORDER, a) - ord(SIZE_ORDER, b)),
      };
    };
    const fLabel = (fk, v) => (fk === "k" ? typeLabel(v) : fk === "g" ? sizeLabel(v) : v);

    /* HTML */
    const sortLabel = () => (SORTS.find(([v]) => v === S.sort) || SORTS[0])[1];
    const colT = (n) => `${n} ${n === 1 ? T("Spalte", "column") : T("Spalten", "columns")}`;
    const densHTML = () => (densOn() ? colsOpts().map((n) => `<button type="button" data-cols="${n}" aria-pressed="${n === cols}" aria-label="${colT(n)}" title="${colT(n)}">${ICO.cols(n)}</button>`).join("") : "");
    const fdTitle = opt.sort ? T("Filtern &amp; Sortieren", "Filter &amp; sort") : "Filter";
    const barHTML = () => `<div class="rvc-bar" role="region" aria-label="${T("Ansicht und Filter", "View and filters")}"><div class="rv-wrap rvc-bar__in">
        ${opt.filters ? `<button type="button" class="rvc-fbtn" data-open="${uid}-fd" aria-haspopup="dialog" aria-controls="${uid}-fd">${ICO.filter}<span class="rv-only-d">Filter</span><span class="rv-only-m">${fdTitle}</span><span class="rvc-fbtn__n" data-fn></span></button>` : ""}
        <span class="rvc-bar__n" aria-live="polite"${showCount ? " data-count" : ""}></span>
        ${opt.sort ? `<span class="rvc-vr rv-only-d"></span><div class="rvc-sort rv-only-d"><button type="button" class="rvc-sort__btn" aria-haspopup="listbox" aria-expanded="false" data-sort-t>${T("Sortieren", "Sort")} <b data-sort-l>${sortLabel()}</b>${RV.icon("chev")}</button>
          <div class="rvc-sort__menu" role="listbox" aria-label="${T("Sortieren", "Sort")}">${SORTS.map(([v, t]) => `<button type="button" role="option" data-sort="${v}" aria-selected="${v === S.sort}">${t}</button>`).join("")}</div></div>` : ""}
        <span class="rvc-vr" data-densvr></span><div class="rvc-dens" role="group" aria-label="${T("Rasteransicht", "Grid view")}" data-dens></div>
      </div></div>`;

    const drawerHTML = () => {
      const F = facets();
      const shirts = all.some((p) => typeKey(p) === "Oversized Shirts");
      const grp = (title, body, cls = "") => `<fieldset class="rvc-fg"><legend>${title}</legend><div class="rvc-fg__l ${cls}">${body}</div></fieldset>`;
      const ck = (fk, v, inner, cls = "") => `<label class="rvc-ck ${cls}" data-o="${fk}"><input type="checkbox" data-fk="${fk}" value="${esc(v)}"${S[fk].has(v) ? " checked" : ""}>${inner}<span class="rvc-ck__t">${esc(fLabel(fk, v))}</span><span class="rvc-ck__n" data-n></span></label>`;
      return `<aside class="rv-panel rv-panel--r rvc-fd" id="${uid}-fd" role="dialog" aria-modal="true" aria-labelledby="${uid}-fdt">
        <div class="rvc-fd__grab" aria-hidden="true"></div>
        <div class="rv-panel__hd"><span class="rv-label" id="${uid}-fdt">${fdTitle}<span class="rvc-fd__on" data-fn2></span></span><button type="button" class="rv-x" data-close data-autofocus aria-label="${T("Schließen", "Close")}">${RV.icon("close")}</button></div>
        <div class="rv-panel__bd rvc-fd__bd">
          ${opt.sort ? grp(T("Sortieren", "Sort"), SORTS.map(([v, t]) => `<label class="rvc-ro"><input type="radio" name="${uid}-so" value="${v}" data-sortr${v === S.sort ? " checked" : ""}><span class="rvc-ro__dot"></span><span>${t}</span></label>`).join(""), "rvc-fg__l--2") : ""}
          ${F.k.length > 1 ? grp(T("Kategorie", "Category"), F.k.map((v) => ck("k", v, '<span class="rvc-ck__box"></span>')).join("")) : ""}
          ${F.f.length > 1 ? grp(T("Farbe", "Colour"), F.f.map(([v, x]) => ck("f", v, `<span class="rvc-ck__sw" style="--c:${esc(x)}"></span>`, "rvc-ck--c")).join(""), "rvc-fg__l--2") : ""}
          ${F.g.length ? grp(T("Größe", "Size"), F.g.map((v) => `<label class="rvc-sz" data-o="g"><input type="checkbox" data-fk="g" value="${esc(v)}"${S.g.has(v) ? " checked" : ""}><span>${esc(sizeLabel(v))}</span></label>`).join(""), "rvc-szs") : ""}
          <p class="rvc-fd__note">${T("Größen gelten für verfügbare Varianten.", "Sizes refer to available variants.")}${shirts ? T(" Alle Shirts sind oversized und unisex geschnitten.", " All shirts are cut oversized and unisex.") : ""}</p>
        </div>
        <div class="rv-panel__ft rvc-fd__ft"><button type="button" class="rv-btn rv-btn--ghost" data-reset>${T("Zurücksetzen", "Reset")}</button><button type="button" class="rv-btn" data-close data-fshow></button></div>
      </aside>`;
    };

    const cardSizes = () => (MQ_M.matches ? `${Math.round(100 / cols)}vw` : `(max-width:1100px) ${Math.round(100 / cols)}vw, ${Math.min(50, Math.round(100 / cols))}vw`);
    /* Items [from, to) in Rasterreihenfolge */
    const itemsHTML = (from, to) => {
      const sizes = cardSizes(), badge = badgeOn();
      return items.slice(from, to).map((x) => {
        if (x.t === "tile") return tileHTML(x.id, x.span, cols);
        let h = RV.card(list[x.i], ci[x.i], { sizes, reveal: true, delay: Math.min(x.c, 4) * 0.08, badge });
        if (opt.extra) h = h.replace(/<\/article>\s*$/, opt.extra(list[x.i], ci[x.i]) + "</article>");
        return h;
      }).join("");
    };
    /* Anzahl Items, damit nP Teile sichtbar sind – immer bis zum Ende der Reihe */
    const itemsFor = (nP) => {
      if (nP >= list.length) return items.length;
      let j = items.findIndex((x) => x.t === "p" && x.i === nP - 1);
      if (j < 0) return 0;
      while (j + 1 < items.length && items[j + 1].r === items[j].r) j++;
      return j + 1;
    };
    const prodsIn = (nI) => items.slice(0, nI).filter((x) => x.t === "p").length;
    const emptyHTML = () => `<div class="rvc-empty"><div class="rvc-empty__m">${RV.monoSVG("currentColor", 1.6)}</div>
      <p class="rv-h3">${T("Keine Teile für diese Auswahl", "No pieces for this selection")}</p><p class="rv-small">${T("Lockere einen Filter oder setz die Auswahl zurück.", "Loosen a filter or reset your selection.")}</p>
      <button type="button" class="rv-btn rv-btn--ghost" data-reset>${T("Filter zurücksetzen", "Reset filters")}</button></div>`;

    /* Anzeige aktualisieren */
    function syncBar() {
      const n = list.length, a = nActive();
      root.querySelectorAll("[data-count]").forEach((e) => (e.textContent = opt.countLabel ? opt.countLabel(n, all.length) : teile(n)));
      const fn = root.querySelector("[data-fn]");
      if (fn) { fn.textContent = a; fn.classList.toggle("is-on", a > 0); }
      const sl = root.querySelector("[data-sort-l]");
      if (sl) sl.textContent = sortLabel();
      root.querySelectorAll("[data-sort]").forEach((b) => b.setAttribute("aria-selected", b.dataset.sort === S.sort));
      const d = root.querySelector("[data-dens]");
      if (d) d.innerHTML = densHTML();
      const vr = root.querySelector("[data-densvr]");
      if (vr) vr.hidden = !densOn() || !(opt.filters || opt.sort || showCount);
      if (bar) bar.hidden = !(opt.filters || opt.sort || showCount || densOn());
      /* aktive Filter als Pillen */
      if (act) {
        const pill = (fk, v) => {
          const sw = fk === "f" ? (all.find((p) => p.c.some((c) => c.n === v)) || { c: [] }).c.find((c) => c.n === v) : null;
          return `<button type="button" class="rvc-pill" data-rmf="${fk}" data-v="${esc(v)}" aria-label="${T(`Filter ${esc(fLabel(fk, v))} entfernen`, `Remove filter ${esc(fLabel(fk, v))}`)}">${sw ? `<i style="--c:${esc(sw.x)}"></i>` : ""}${fk === "g" ? T("Größe ", "Size ") : ""}${esc(fLabel(fk, v))}${RV.icon("close")}</button>`;
        };
        act.innerHTML = a ? [...S.k].map((v) => pill("k", v)).concat([...S.f].map((v) => pill("f", v)), [...S.g].map((v) => pill("g", v))).join("") + `<button type="button" class="rvc-clear" data-reset>${T("Alle zurücksetzen", "Clear all")}</button>` : "";
      }
      syncDrawer();
    }
    function syncDrawer() {
      if (!drawer) return;
      drawer.querySelectorAll("[data-fk]").forEach((inp) => {
        const fk = inp.dataset.fk, v = inp.value, n = facetCount(fk, v);
        inp.checked = S[fk].has(v);
        const lab = inp.closest("label");
        const nEl = lab.querySelector("[data-n]");
        if (nEl) nEl.textContent = n;
        const off = n === 0 && !inp.checked;
        lab.classList.toggle("is-off", off);
        inp.disabled = off;
      });
      drawer.querySelectorAll("[data-sortr]").forEach((r) => (r.checked = r.value === S.sort));
      const a = nActive();
      const on = drawer.querySelector("[data-fn2]");
      on.textContent = a ? ` (${a})` : "";
      drawer.querySelector("[data-fshow]").textContent = list.length ? T(`${teile(list.length)} anzeigen`, `Show ${teile(list.length)}`) : T("Keine Treffer", "No results");
      drawer.querySelector(".rvc-fd__ft [data-reset]").disabled = !a;
    }
    function syncMore() {
      const n = list.length;
      if (!more) return;
      if (n <= STEP && rendered >= n) { more.innerHTML = ""; return; }
      const pct = Math.round((rendered / n) * 100);
      more.innerHTML = `<p class="rvc-more__t">${rendered} ${T("von", "of")} ${n}</p><div class="rvc-more__bar" role="progressbar" aria-valuemin="0" aria-valuemax="${n}" aria-valuenow="${rendered}" aria-label="${T("Angezeigte Teile", "Pieces shown")}"><i style="width:${pct}%"></i></div>
        ${rendered < n ? `<button type="button" class="rv-btn rv-btn--ghost" data-more>${T("Mehr laden", "Load more")}</button>` : `<p class="rvc-more__done">${it(T("Alle Teile angezeigt.", "All pieces shown."))}</p>`}`;
    }
    function syncURL() {
      if (!opt.sync) return;
      const u = new URLSearchParams();
      if (S.k.size) u.set("k", [...S.k].join(","));
      if (S.f.size) u.set("f", [...S.f].join(","));
      if (S.g.size) u.set("g", [...S.g].join(","));
      if (S.sort !== "empf") u.set("sort", S.sort);
      opt.sync(u);
    }

    function render(fade) {
      list = sorted(filtered());
      cols = getCols(list.length);
      const tiles = (opt.tiles || []).filter(tileOk);
      const n = list.length, placed = tiles.filter((id, i) => (i ? n >= Math.max(30, 8 * cols) : n >= Math.max(12, 3 * cols)));
      const fillers = opt.fill === false ? [] : [...new Set((opt.tiles || []).concat(FILL))]
        .filter((id) => tileOk(id) && !placed.includes(id)).sort((a, b) => (TILE[a].kind === "img") - (TILE[b].kind === "img"));
      const bst = best(list, cols, tiles, fillers, S.f.size ? S.f : null, S.sort === "pa" || S.sort === "pd" ? (a, b) => a.p === b.p : null);
      items = bst.items;
      list = bst.ar.order; ci = bst.ar.ci;
      shownItems = itemsFor(Math.min(S.shown, list.length));
      rendered = prodsIn(shownItems);
      const paint = () => {
        grid.style.setProperty("--cols", cols);
        grid.dataset.cols = cols;
        grid.classList.toggle("is-feature", list.length === 1 && cols === 2 && bp() !== "m");
        grid.innerHTML = list.length ? itemsHTML(0, shownItems) : emptyHTML();
        syncBar(); syncMore();
        RV.reveal(grid); RV.wish.sync();
        grid.classList.remove("is-busy");
        opt.onPaint && opt.onPaint(grid);
      };
      if (fade && !REDUCE.matches && !document.documentElement.classList.contains("rv-static")) { grid.classList.add("is-busy"); setTimeout(paint, 260); }
      else paint();
      opt.onChange && opt.onChange(S, list);
    }
    function loadMore() {
      const from = shownItems, to = itemsFor(Math.min(rendered + STEP, list.length));
      if (to <= from) return;
      grid.insertAdjacentHTML("beforeend", itemsHTML(from, to));
      const firstNew = grid.children[from];
      shownItems = to; rendered = prodsIn(to); S.shown = rendered;
      RV.reveal(grid); RV.wish.sync(); syncMore();
      opt.onPaint && opt.onPaint(grid);
      const a = firstNew && firstNew.querySelector("a");
      if (a) a.focus({ preventScroll: true });
    }
    /* nach Filterwechsel zurück an den Anfang des Rasters, falls weiter unten */
    const anchor = () => (bar && !bar.hidden ? bar : grid);
    function toTop() {
      const y = anchor().getBoundingClientRect().top + window.scrollY - (lastTop > 0 ? lastTop : 0);
      if (window.scrollY > y + 4) window.scrollTo({ top: y, behavior: REDUCE.matches ? "auto" : "smooth" });
    }
    function apply() { S.shown = STEP; render(true); syncURL(); toTop(); }

    /* Events */
    function onClick(e) {
      const t = e.target;
      const sortT = t.closest("[data-sort-t]");
      const box = root.querySelector(".rvc-sort");
      if (sortT) { const o = !box.classList.contains("is-open"); box.classList.toggle("is-open", o); sortT.setAttribute("aria-expanded", o); if (o) { const s = box.querySelector('[aria-selected="true"]'); s && s.focus(); } return; }
      const so = t.closest("[data-sort]");
      if (so) { S.sort = so.dataset.sort; closeSort(true); apply(); return; }
      const dc = t.closest(".rvc-dens [data-cols]"); /* nicht das Raster selbst (trägt data-cols) */
      if (dc) { setCols(+dc.dataset.cols); render(true); return; }
      const rm = t.closest("[data-rmf]");
      if (rm) { S[rm.dataset.rmf].delete(rm.dataset.v); apply(); return; }
      if (t.closest("[data-reset]")) { S.k.clear(); S.f.clear(); S.g.clear(); apply(); return; }
      if (t.closest("[data-more]")) { loadMore(); return; }
    }
    function closeSort(focusBtn) {
      const box = root && root.querySelector(".rvc-sort");
      if (!box || !box.classList.contains("is-open")) return;
      box.classList.remove("is-open");
      const b = box.querySelector("[data-sort-t]"); b.setAttribute("aria-expanded", "false");
      if (focusBtn) b.focus();
    }
    function onDocClick(e) { if (!e.target.closest(".rvc-sort")) closeSort(false); }
    function onKey(e) {
      if (e.key === "Escape") closeSort(true);
      const box = root.querySelector(".rvc-sort.is-open");
      if (box && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
        e.preventDefault();
        const os = [...box.querySelectorAll("[data-sort]")], i = os.indexOf(document.activeElement);
        os[(i + (e.key === "ArrowDown" ? 1 : -1) + os.length) % os.length].focus();
      }
    }
    function onDrawer(e) {
      const inp = e.target;
      if (inp.matches("[data-fk]")) { const set = S[inp.dataset.fk]; inp.checked ? set.add(inp.value) : set.delete(inp.value); apply(); }
      else if (inp.matches("[data-sortr]")) { S.sort = inp.value; apply(); }
    }
    function onDrawerClick(e) { if (e.target.closest("[data-reset]")) { S.k.clear(); S.f.clear(); S.g.clear(); apply(); } }
    function onScroll() {
      if (!bar || bar.hidden) return;
      const hdr = $("#rv-hdr");
      const top = !hdr || hdr.classList.contains("is-hidden") ? 0 : hdr.offsetHeight;
      if (top !== lastTop) { bar.style.top = top + "px"; lastTop = top; }
      bar.classList.toggle("is-stuck", window.scrollY > 40 && bar.getBoundingClientRect().top <= top + 1);
    }
    let raf = 0;
    const onScrollRaf = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; onScroll(); }); };
    let offBP = null;
    /* Fokus zurück auf den Filter-Knopf, wenn der Drawer schließt */
    let mo;

    return {
      S,
      mount(el) {
        root = el;
        root.innerHTML = `${barHTML()}<div class="rv-wrap"><div class="rvc-act" data-act></div><div class="rvc-grid" data-grid></div><div class="rvc-more" data-moreb></div></div>`;
        bar = root.querySelector(".rvc-bar"); grid = root.querySelector("[data-grid]"); more = root.querySelector("[data-moreb]"); act = root.querySelector("[data-act]");
        if (opt.filters) {
          document.body.insertAdjacentHTML("beforeend", drawerHTML());
          drawer = document.getElementById(uid + "-fd");
          drawer.addEventListener("change", onDrawer);
          drawer.addEventListener("click", onDrawerClick);
          mo = new MutationObserver(() => {
            if (!drawer.classList.contains("is-on") && drawer.contains(document.activeElement)) { const b = root.querySelector(".rvc-fbtn"); b && b.focus({ preventScroll: true }); }
          });
          mo.observe(drawer, { attributes: true, attributeFilter: ["class"] });
        }
        root.addEventListener("click", onClick);
        document.addEventListener("click", onDocClick);
        document.addEventListener("keydown", onKey);
        window.addEventListener("scroll", onScrollRaf, { passive: true });
        window.addEventListener("resize", onScrollRaf, { passive: true });
        offBP = onBP(() => render(false));
        render(false);
        onScroll();
      },
      setProducts(l) { all = l.slice(); pos = new Map(all.map((p, i) => [p.h, i])); S.shown = Math.max(STEP, Math.min(S.shown, all.length)); render(false); },
      setTypes(arr) { S.k = new Set(arr); apply(); },
      count: () => list.length,
      scrollTo() { const y = anchor().getBoundingClientRect().top + window.scrollY - (lastTop > 0 ? lastTop : 0); window.scrollTo({ top: y, behavior: REDUCE.matches ? "auto" : "smooth" }); },
      destroy() {
        if (root) root.removeEventListener("click", onClick);
        document.removeEventListener("click", onDocClick);
        document.removeEventListener("keydown", onKey);
        window.removeEventListener("scroll", onScrollRaf);
        window.removeEventListener("resize", onScrollRaf);
        if (offBP) offBP();
        if (raf) cancelAnimationFrame(raf);
        if (mo) mo.disconnect();
        if (drawer) { if (drawer.classList.contains("is-on")) RV.closeAll(); drawer.remove(); drawer = null; }
      },
    };
  }

  /* ---------- Gemeinsame Bausteine ---------- */
  const COLL_IMG = (h) => { const k = BANNER[h]; const b = k && B[k]; return b ? { d: b.m || b.d, m: b.m || b.d } : null; };
  function collTiles(hs, eyebrow = T("Kollektion", "Collection")) {
    return hs.map((h, i) => {
      const c = RV.coll(h), im = COLL_IMG(h) || (c && c.img ? { d: c.img } : null);
      if (!c || !im) return "";
      return `<a class="rvc-ct" href="${RV.href.c(h)}" data-reveal style="--d:${i * 0.1}s"><span class="rv-ph">${RV.imgTag(im.d, { w: 700, sizes: "(max-width:760px) 78vw, 30vw", alt: "", ws: [480, 720, 960, 1200] })}</span>
        <span class="rvc-ct__shade"></span><span class="rvc-ct__cap"><span class="rv-eyebrow">${esc(eyebrow)}</span><span class="rv-h2">${HERO[h] ? HERO[h].t : TITLE[h] || esc(c.t)}</span><span class="rvc-ct__n">${teile(cnt(h))}</span></span></a>`;
    }).join("");
  }
  const servHTML = () => `<section class="rvc-serv" aria-label="Service"><div class="rv-wrap rvc-serv__in">
      <div class="rvc-serv__it"><b>${T("Kostenloser Versand", "Free shipping")}</b><span>${T("DE · CH, ohne Mindestbestellwert", "DE · CH, no minimum order")}</span></div>
      <div class="rvc-serv__it"><b>${T("In Deutschland bedruckt", "Printed in Germany")}</b><span>${T("erst nach deiner Bestellung", "only after you order")}</span></div>
      <div class="rvc-serv__it"><b>${T("DHL mit Tracking", "DHL with tracking")}</b><span>${T("Deutschland in 2–5 Werktagen", "Germany in 2–5 business days")}</span></div>
      <div class="rvc-serv__it"><b>${T("14 Tage Widerruf", "14-day withdrawal")}</b><span>${T("Anprobieren ausdrücklich erlaubt", "trying on explicitly allowed")}</span></div>
    </div></section>`;
  const descHTML = (rest, cls = "") => (rest ? `<div class="rvc-desc ${cls}"><p class="rvc-desc__more" id="rvc-desc-more" hidden>${esc(rest)}</p><button type="button" class="rv-link rvc-desc__btn" aria-expanded="false" aria-controls="rvc-desc-more" data-desc>${T("Mehr lesen", "Read more")}</button></div>` : "");
  const bindDesc = (el) => {
    const b = el.querySelector("[data-desc]");
    if (!b) return;
    b.addEventListener("click", () => { const p = el.querySelector("#rvc-desc-more"); const o = p.hidden; p.hidden = !o; b.setAttribute("aria-expanded", o); b.textContent = o ? T("Weniger", "Less") : T("Mehr lesen", "Read more"); });
  };
  /* Zustand in der echten URL (Vorschau-/fremde Parameter bleiben erhalten) */
  const setQuery = (keys, u) => {
    try {
      const cur = new URLSearchParams(location.search);
      keys.forEach((k) => cur.delete(k));
      u.forEach((v, k) => cur.set(k, v));
      const s = cur.toString();
      history.replaceState(history.state, "", location.pathname + (s ? "?" + s : "") + location.hash);
    } catch (e) {}
  };

  /* ==========================================================================
     KOLLEKTION
     ========================================================================== */
  let inst = null;
  const kill = () => { if (inst) { inst.forEach((f) => { try { f(); } catch (e) {} }); inst = null; } };

  function heroHTML(h, c) {
    const b = B[BANNER[h]] || {}, H = HERO[h] || { t: esc(c.t), tag: "" };
    return `<section class="rvc-hero rvc-hero--${esc(h)}" aria-label="${esc(c.t)}">
      <div class="rvc-hero__media"><picture>${b.m ? `<source media="(max-width:760px)" srcset="${RV.srcset(b.m, [480, 720, 960, 1200])}" sizes="100vw">` : ""}
        ${RV.imgTag(b.d, { w: 1800, sizes: "100vw", alt: T(`REVØRA ${c.t} – Kampagnenbild, Rückenmotive. KI-generierte Abbildung`, `REVØRA ${c.t} – campaign image, back motifs. AI-generated image`), eager: true, ws: [960, 1280, 1600, 2000, 2400] })}</picture></div>
      <div class="rvc-hero__shade"></div>
      <div class="rv-wrap rvc-hero__in">
        <div class="rvc-hero__l">
          <div class="rv-eyebrow" data-reveal style="--d:.15s">${T("Kollektion", "Collection")}</div>
          <h1 class="rvc-hero__t" data-reveal style="--d:.28s">${H.t}</h1>
          ${H.tag ? `<p class="rvc-hero__tag" data-reveal style="--d:.42s">${H.tag}</p>` : ""}
        </div>
        <div class="rvc-hero__r" data-reveal="fade" style="--d:.6s">
          <button type="button" class="rvc-cue" data-cue><span>${T("Entdecken", "Discover")}</span><i aria-hidden="true"></i></button>
        </div>
      </div>
    </section>`;
  }
  function headHTML(h, c, n, lead, rest) {
    return `<header class="rvc-head"><div class="rv-wrap">
      <div class="rvc-orn rv-eyebrow" data-reveal="fade">${T("Kollektion", "Collection")}</div>
      <h1 class="rvc-head__t" data-reveal style="--d:.1s">${TITLE[h] || esc(c.t)}</h1>
      <div class="rvc-head__n" data-reveal="fade" style="--d:.2s">${teile(n)}</div>
      ${lead ? `<p class="rvc-head__lead" data-reveal="fade" style="--d:.28s">${keep(lead)}</p>` : ""}
      ${descHTML(rest)}
    </div></header>`;
  }
  function chipsHTML(h, prods) {
    const fm = FAM.find((f) => f.includes(h));
    if (fm) {
      return `<nav class="rvc-chips" aria-label="${T("Unterkollektionen", "Subcollections")}"><div class="rv-wrap"><div class="rvc-chips__row">${fm.map((x) => {
        const c = RV.coll(x); if (!c) return "";
        const on = x === h;
        return `<a class="rvc-chip${on ? " is-on" : ""}" href="${RV.href.c(x)}"${on ? ' aria-current="page"' : ""}>${esc(CHIP_T[x] || c.t)}<span class="rvc-chip__n">${cnt(x)}</span></a>`;
      }).join("")}</div></div></nav>`;
    }
    const t = new Map();
    prods.forEach((p) => t.set(typeKey(p), (t.get(typeKey(p)) || 0) + 1));
    if (t.size < 2) return "";
    const ks = [...t.keys()].sort((a, b) => ord(TYPE_ORDER, a) - ord(TYPE_ORDER, b));
    return `<nav class="rvc-chips" aria-label="${T("Kategorien", "Categories")}"><div class="rv-wrap"><div class="rvc-chips__row">
      <button type="button" class="rvc-chip is-on" data-qk="" aria-pressed="true">${T("Alle", "All")}<span class="rvc-chip__n">${prods.length}</span></button>
      ${ks.map((k) => `<button type="button" class="rvc-chip" data-qk="${esc(k)}" aria-pressed="false">${esc(typeLabel(k))}<span class="rvc-chip__n">${t.get(k)}</span></button>`).join("")}</div></div></nav>`;
  }

  function renderCollection(el, ctx) {
    kill();
    const offs = [];
    inst = offs;
    ingest(data());
    const h = ctx.params.h, c = RV.coll(h);
    if (!c) {
      el.innerHTML = `<div class="rvc"><header class="rvc-head rvc-head--nf"><div class="rv-wrap"><div class="rvc-orn rv-eyebrow">${T("Kollektion", "Collection")}</div>
        <h1 class="rvc-head__t">${T("Nicht " + it("gefunden"), "Not " + it("found"))}</h1><p class="rvc-head__lead">${T("Diese Kollektion gibt es nicht (mehr). Alle Teile findest du hier.", "This collection no longer exists. You can find all pieces here.")}</p>
        <div class="rvc-head__cta"><a class="rv-btn" href="${RV.href.c("all")}">${T("Alle Teile", "All pieces")}</a></div></div></header></div>`;
      return;
    }
    const prods = RV.collProducts(h), n = prods.length;
    const banner = !!(BANNER[h] && B[BANNER[h]]);
    const small = n <= 3;
    /* Kino-Kollektionen: eigener kurzer Lead, „Mehr lesen“ = ganzer Live-Text; sonst erster Satz + Rest */
    const [lead, rest] = banner && HERO[h] && HERO[h].lead ? [HERO[h].lead, clean(c.d)] : LEAD[h] || split1(clean(c.d));
    const others = ["winter", "azur-club", "riviera", "t-shirts"].filter((x) => x !== h).slice(0, 3);

    el.innerHTML = `<div class="rvc${small ? " rvc--small" : ""}">
      ${banner ? heroHTML(h, c) + (lead ? `<section class="rvc-intro"><div class="rv-wrap"><p class="rvc-intro__lead" data-reveal>${keep(lead)}</p>${descHTML(rest)}</div></section>` : "") : headHTML(h, c, n, lead, rest)}
      ${chipsHTML(h, prods)}
      <div data-lister></div>
      ${servHTML()}
      <section class="rvc-next"><div class="rv-wrap"><div class="rvc-next__hd"><h2 class="rv-h2" data-reveal>${T('<span class="rvc-kw">W</span>eiter ' + it("entdecken"), "Keep " + it("exploring"))}</h2><a class="rv-link rv-only-d" href="${RV.href.c("all")}">${T("Alle Teile", "All pieces")}</a></div>
        <div class="rvc-next__row">${collTiles(others)}</div></div></section>
    </div>`;
    bindDesc(el);

    const chipRow = el.querySelector(".rvc-chips__row");
    const lister = createLister({
      products: prods, filters: !small, sort: !small, small, count: !small, query: ctx.query, badge: h !== "neu-eingetroffen",
      tiles: TILES[h] || TILES._,
      sync: (u) => setQuery(["k", "f", "g", "sort"], u),
      onChange: (S) => {
        el.querySelectorAll("[data-qk]").forEach((b) => {
          const on = b.dataset.qk === "" ? S.k.size === 0 : S.k.size === 1 && S.k.has(b.dataset.qk);
          b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on);
        });
      },
    });
    lister.mount(el.querySelector("[data-lister]"));
    offs.push(() => lister.destroy());

    el.querySelectorAll("[data-qk]").forEach((b) => b.addEventListener("click", () => lister.setTypes(b.dataset.qk ? [b.dataset.qk] : [])));
    /* aktiven Chip mobil ins Bild holen (ohne die Seite zu scrollen) */
    const onChip = chipRow && chipRow.querySelector(".is-on");
    if (onChip && chipRow.scrollWidth > chipRow.clientWidth) chipRow.scrollLeft = Math.max(0, onChip.offsetLeft - 16);

    const cue = el.querySelector("[data-cue]");
    if (cue) cue.addEventListener("click", () => lister.scrollTo());

    /* Hero: sanfter Parallax + Ausblenden der Schrift */
    const hero = el.querySelector(".rvc-hero");
    if (hero && !REDUCE.matches) {
      const media = hero.querySelector(".rvc-hero__media"), txt = hero.querySelector(".rvc-hero__in");
      let raf = 0;
      const run = () => {
        raf = 0;
        const y = window.scrollY, H = hero.offsetHeight;
        if (y > H * 1.1) return;
        media.style.transform = y > 0 && !MQ_M.matches ? `translate3d(0,${(y * 0.32).toFixed(1)}px,0)` : "";
        txt.style.transform = y > 0 ? `translate3d(0,${(y * 0.12).toFixed(1)}px,0)` : "";
        txt.style.opacity = y > 0 ? Math.max(0, 1 - y / (H * 0.75)).toFixed(3) : "";
      };
      const on = () => { if (!raf) raf = requestAnimationFrame(run); };
      window.addEventListener("scroll", on, { passive: true });
      offs.push(() => { window.removeEventListener("scroll", on); if (raf) cancelAnimationFrame(raf); });
    }
  }

  RV.page("collection", {
    title: (ctx) => { const c = RV.coll(ctx.params.h); return (c ? c.t : T("Kollektion", "Collection")) + " — REVØRA"; },
    header: (ctx) => (BANNER[ctx.params.h] && B[BANNER[ctx.params.h]] && (data().c || {}).h === ctx.params.h ? "over" : "solid"),
    render: renderCollection,
    destroy: kill,
  });

  /* ==========================================================================
     MERKLISTE — mit Größenwahl + In den Warenkorb je Karte
     (Teile der Merkliste kommen voll über /products/<h>.js, damit Varianten-IDs stimmen)
     ========================================================================== */
  const curCi = (card) => { const on = card.querySelector(".rv-sw button.is-on"); return on ? +on.dataset.ci : +card.dataset.ci || 0; };
  const buyHTML = (p, ci) => {
    const one = !p.s.length;
    const sizes = one ? "" : `<div class="rvc-buy__s" role="group" aria-label="${T("Größe wählen", "Choose size")}">${p.s.map((s, si) => {
      const ok = RV.isAvail(p, ci, si);
      return `<button type="button" class="rvc-buy__z" data-si="${si}" aria-pressed="false"${ok ? "" : " disabled"} aria-label="${T("Größe", "Size")} ${esc(s)}${ok ? "" : T(", nicht verfügbar", ", unavailable")}">${esc(s)}</button>`;
    }).join("")}</div>`;
    return `<div class="rvc-buy" data-buy${one ? ' data-one="1"' : ""}>${sizes}<button type="button" class="rv-btn rvc-buy__add" data-add>${T("In den Warenkorb", "Add to bag")}</button></div>`;
  };
  const syncBuy = (card) => {
    const p = RV.prod(card.dataset.h), ci = curCi(card), box = card.querySelector("[data-buy]");
    if (!p || !box) return;
    box.querySelectorAll("[data-si]").forEach((b) => {
      const ok = RV.isAvail(p, ci, +b.dataset.si);
      b.disabled = !ok;
      if (!ok && b.getAttribute("aria-pressed") === "true") { b.setAttribute("aria-pressed", "false"); delete box.dataset.si; }
    });
  };
  const wishReady = () => RV.wish.list().every((h) => { const p = RV.prod(h); return p && !p.slim && p.v.length && p.v[0][0]; });

  function renderWish(el) {
    kill();
    const offs = [];
    inst = offs;
    /* Vorschläge (Neu eingetroffen) kompakt aus Liquid — als „slim“ markiert, damit /products/h.js sie bei Bedarf voll nachlädt */
    ingest(data(), { slim: true });
    if (!wishReady()) {
      el.innerHTML = `<div class="rvc rvc-wait" aria-busy="true"><header class="rvc-head rvc-head--wish"><div class="rv-wrap"><div class="rvc-orn rv-eyebrow">${T("Merkliste", "Wishlist")}</div></div></header></div>`;
      RV.fetchProducts(RV.wish.list()).then(() => { if (inst !== offs) return; drawWish(el); RV.reveal(el); RV.wish.sync(); });
      return;
    }
    drawWish(el);
  }
  function drawWish(el) {
    kill();
    const offs = [];
    inst = offs;
    const get = () => RV.wish.list().map(RV.prod).filter((p) => p && !p.slim);
    let l = get();
    if (!l.length) {
      el.innerHTML = `<div class="rvc">
        <header class="rvc-head rvc-head--wish rvc-head--void"><div class="rv-wrap">
          <div class="rvc-orn rv-eyebrow" data-reveal="fade">${T("Merkliste", "Wishlist")}</div>
          <h1 class="rvc-head__t" data-reveal style="--d:.1s">${T("Noch nichts " + it("gemerkt."), "Nothing saved " + it("yet."))}</h1>
          <p class="rvc-head__lead" data-reveal="fade" style="--d:.2s">${T("Mit dem Herz an einem Teil merkst du es dir – es wartet dann hier, bis du dich entschieden hast.", "Tap the heart on a piece to save it – it waits here until you have decided.")}</p>
          <div class="rvc-void__cta" data-reveal="fade" style="--d:.3s"><a class="rv-btn" href="${RV.href.c("neu-eingetroffen")}">${T("Neu entdecken", "Discover new")}</a><a class="rv-btn rv-btn--ghost" href="${RV.href.c("all")}">${T("Alle Teile", "All pieces")}</a></div>
        </div></header>
        <section class="rvc-also"><div class="rv-wrap"><div class="rvc-next__hd"><h2 class="rv-h2" data-reveal>${T("Neu " + it("eingetroffen"), "New " + it("arrivals"))}</h2><a class="rv-link" href="${RV.href.c("neu-eingetroffen")}">${T("Alle ansehen", "View all")}</a></div>
          ${miniGrid("neu-eingetroffen", 4)}</div></section>
        ${servHTML()}</div>`;
      offs.push(onBP(() => paintMini(el)));
      /* Herz auf einer Vorschlagskarte -> Seite neu aufbauen */
      const onH = (e) => { if (e.target.closest(".rv-heart")) setTimeout(() => { if (RV.wish.list().length) { renderWish(el); RV.reveal(el); } }, 0); };
      el.addEventListener("click", onH);
      offs.push(() => el.removeEventListener("click", onH));
      return;
    }
    const note = (n) => `${teile(n)} · ${T("auf diesem Gerät gespeichert", "saved on this device")}`;
    el.innerHTML = `<div class="rvc">
      <header class="rvc-head rvc-head--wish"><div class="rv-wrap">
        <div class="rvc-orn rv-eyebrow" data-reveal="fade">${T("Merkliste", "Wishlist")}</div>
        <h1 class="rvc-head__t" data-reveal style="--d:.1s">${T("Deine " + it("Auswahl"), "Your " + it("selection"))}</h1>
        <div class="rvc-head__n" data-reveal="fade" style="--d:.2s" data-wn>${note(l.length)}</div>
      </div></header>
      <div data-lister></div>
      <div class="rv-wrap rvc-wish__cta"><a class="rv-btn rv-btn--ghost" href="${RV.href.c("neu-eingetroffen")}">${T("Weiter entdecken", "Keep exploring")}</a></div>${servHTML()}</div>`;
    const lister = createLister({ products: l, filters: false, sort: false, tiles: null, count: false, densMin: 4, extra: buyHTML });
    lister.mount(el.querySelector("[data-lister]"));
    offs.push(() => lister.destroy());

    const onClickW = (e) => {
      /* Farbwechsel am Desktop: Größen-Verfügbarkeit nachziehen (nach dem globalen Swatch-Handler) */
      const sw = e.target.closest(".rv-card .rv-sw button");
      if (sw) { const card = sw.closest(".rv-card"); setTimeout(() => syncBuy(card), 0); return; }
      const z = e.target.closest(".rvc-buy__z");
      if (z) {
        const box = z.closest("[data-buy]");
        box.querySelectorAll(".rvc-buy__z").forEach((b) => b.setAttribute("aria-pressed", b === z ? "true" : "false"));
        box.dataset.si = z.dataset.si; box.classList.remove("is-ask");
        return;
      }
      const add = e.target.closest("[data-add]");
      if (add) {
        const card = add.closest(".rv-card"), box = add.closest("[data-buy]"), p = RV.prod(card.dataset.h);
        if (!p) return;
        if (box.dataset.one) { RV.cart.add(p, curCi(card), 0); return; }
        if (box.dataset.si == null) {
          box.classList.remove("is-ask"); void box.offsetWidth; box.classList.add("is-ask");
          RV.toast(T("Bitte zuerst eine Größe wählen", "Please choose a size first"));
          const first = box.querySelector(".rvc-buy__z:not([disabled])"); first && first.focus();
          return;
        }
        RV.cart.add(p, curCi(card), +box.dataset.si);
        return;
      }
      /* Entfernen mit sanftem Ausblenden */
      const hb = e.target.closest(".rv-heart[data-h]");
      if (!hb) return;
      const card = hb.closest(".rv-card"), hh = hb.dataset.h;
      setTimeout(() => {
        if (RV.wish.has(hh)) return;
        card && card.classList.add("rvc-gone");
        setTimeout(() => {
          l = get();
          if (!l.length) { kill(); drawWish(el); RV.reveal(el); return; }
          lister.setProducts(l);
          const wn = el.querySelector("[data-wn]");
          if (wn) wn.textContent = note(l.length);
        }, REDUCE.matches ? 0 : 480);
      }, 0);
    };
    el.addEventListener("click", onClickW);
    offs.push(() => el.removeEventListener("click", onClickW));
  }
  RV.page("merkliste", { title: T("Merkliste", "Wishlist") + " — REVØRA", header: "solid", render: renderWish, destroy: kill });

  /* ==========================================================================
     SUCHE — Treffer aus der Shopify-Suche (search.results); beim Tippen lädt die
     Section über die Section-Rendering-API neu (?section_id=…), ohne Seitenwechsel.
     ========================================================================== */
  const SUGG = ["Hoodie", "Zip-Hoodie", "Sweatshirt", "Longsleeve", T("Jacke", "Jacket"), "Cap", "Riviera", "Azur", "Navy", "Citrons", "Vin Chaud", "Dolce Vita"];
  const normS = (s) => s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ø/g, "o");
  /* Ergebnis-Handles aus einem Datenblock (nur Suchtreffer, nicht die Vorschläge) */
  const hits = (d) => (d && d.sh ? d.sh : []).map(RV.prod).filter(Boolean);
  /* Shopify findet auch Treffer im Beschreibungstext („Hoodie“ in jedem Shirt-Text). Passen Teile direkt
     (Titel, Art, Farbe), zeigen wir nur diese – in der Reihenfolge der Shopify-Suche; sonst alle Treffer. */
  const strong = (q, list) => {
    const words = normS(q).split(/\s+/).filter(Boolean);
    const sel = list.filter((p) => { const s = normS([p.t, p.ty, typeKey(p), typeLabel(typeKey(p)), p.c.map((c) => c.n).join(" "), (p.tags || []).join(" ")].join(" ")); return words.every((w) => s.includes(w)); });
    return sel.length ? sel : list;
  };
  let sReq = 0;
  async function fetchSearch(q) {
    const d0 = data();
    const u = new URLSearchParams({ q, type: "product", "options[prefix]": "last", section_id: d0.sid || "" });
    const r = await fetch(RV.pv(RV.cfg.root + "search?" + u.toString()), { credentials: "same-origin", headers: { Accept: "text/html" } });
    if (!r.ok) throw new Error("search " + r.status);
    const doc = new DOMParser().parseFromString(await r.text(), "text/html");
    const s = doc.querySelector('script[type="application/json"][data-rvc-data]');
    const d = s ? JSON.parse(s.textContent) : { sh: [] };
    ingest(d);
    return d;
  }

  function renderSearch(el, ctx) {
    kill();
    const offs = [];
    inst = offs;
    let lister = null;
    const d0 = data();
    ingest(d0);
    const q0 = String(ctx.params.q != null ? ctx.params.q : ctx.query.q || "").trim();
    el.innerHTML = `<div class="rvc rvc-s">
      <section class="rvc-shead"><div class="rv-wrap">
        <h1 class="rv-eyebrow rvc-shead__eb">${T("Suche", "Search")}</h1>
        <form class="rvc-sf" role="search" action="${RV.cfg.root}search" method="get" data-sf>
          <input type="hidden" name="type" value="product">
          <label class="rvc-sf__f"><span class="rvc-sr">${T("Suchbegriff", "Search term")}</span>${RV.icon("search")}<input type="search" name="q" id="rvc-sq" value="${esc(q0)}" placeholder="${T("Wonach suchst du?", "What are you looking for?")}" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search"></label>
          <button type="button" class="rvc-sf__x" aria-label="${T("Eingabe löschen", "Clear input")}" data-sx>${RV.icon("close")}</button>
        </form>
        <div class="rvc-schips"><span class="rvc-schips__l">${T("Vorschläge", "Suggestions")}</span>${SUGG.map((s) => `<button type="button" class="rvc-chip rvc-chip--s" data-sg="${esc(s)}">${esc(s)}</button>`).join("")}</div>
        <div class="rvc-scoll" data-scoll></div>
      </div></section>
      <div data-sbody></div>
    </div>`;
    const inp = el.querySelector("#rvc-sq"), body = el.querySelector("[data-sbody]"), form = el.querySelector("[data-sf]"), scoll = el.querySelector("[data-scoll]");
    let cur = null;

    /* Anzeige für q mit fertiger Trefferliste res */
    const paintS = (q, res) => {
      if (lister) { lister.destroy(); lister = null; }
      const words = normS(q).split(/\s+/).filter(Boolean);
      const cm = q ? D.collections.filter((c) => words.every((w) => normS(c.t + " " + c.h).includes(w))).slice(0, 4) : [];
      scoll.innerHTML = cm.length ? `<span class="rvc-schips__l">${T("Kollektionen", "Collections")}</span>${cm.map((c) => `<a class="rvc-chip rvc-chip--s" href="${RV.href.c(c.h)}">${esc(c.t)}<span class="rvc-chip__n">${cnt(c.h)}</span></a>`).join("")}` : "";
      if (!q) {
        body.innerHTML = `<section class="rvc-sidle"><div class="rv-wrap"><div class="rvc-next__hd"><h2 class="rv-h2">${T("Die " + it("Kollektionen"), "The " + it("collections"))}</h2></div>
          <div class="rvc-next__row rvc-next__row--4">${collTiles(["winter", "azur-club", "riviera", "t-shirts"])}</div></div></section>
          <section class="rvc-also"><div class="rv-wrap"><div class="rvc-next__hd"><h2 class="rv-h2">${T("Neu " + it("eingetroffen"), "New " + it("arrivals"))}</h2><a class="rv-link" href="${RV.href.c("neu-eingetroffen")}">${T("Alle ansehen", "View all")}</a></div>
          ${miniGrid("neu-eingetroffen", 8)}</div></section>`;
      } else if (!res.length) {
        body.innerHTML = `<section class="rvc-void rvc-void--s"><div class="rv-wrap rvc-void__in">
            <p class="rv-h2">${T("Keine Treffer für ", "No results for ")}${it(T("„" + esc(q) + "“", "“" + esc(q) + "”"))}</p>
            <p class="rvc-void__t">${T("Versuch ein Motiv, eine Farbe oder eine Kategorie – zum Beispiel einen der Vorschläge oben.", "Try a motif, a colour or a category – for example one of the suggestions above.")}</p>
            <div class="rvc-void__cta"><a class="rv-btn" href="${RV.href.c("all")}">${T("Alle Teile", "All pieces")}</a></div></div></section>
            <section class="rvc-also"><div class="rv-wrap"><div class="rvc-next__hd"><h2 class="rv-h2">${T("Neu " + it("eingetroffen"), "New " + it("arrivals"))}</h2><a class="rv-link" href="${RV.href.c("neu-eingetroffen")}">${T("Alle ansehen", "View all")}</a></div>
            ${miniGrid("neu-eingetroffen", 4)}</div></section>`;
      } else {
        const n = res.length;
        body.innerHTML = `<div class="rvc-sres"><div class="rv-wrap"><p class="rvc-sres__t" aria-live="polite">${n} ${n === 1 ? T("Ergebnis", "result") : T("Ergebnisse", "results")} ${T("für", "for")} ${it(T("„" + esc(q) + "“", "“" + esc(q) + "”"))}</p></div><div data-lister></div></div>`;
        lister = createLister({ products: res, filters: true, sort: true, tiles: null, query: {}, count: false });
        lister.mount(body.querySelector("[data-lister]"));
      }
      RV.reveal(body);
      RV.wish.sync();
    };
    const update = async (q, push) => {
      q = q.trim();
      form.classList.toggle("has-q", !!q);
      el.querySelectorAll("[data-sg]").forEach((b) => b.classList.toggle("is-on", !!q && normS(b.dataset.sg) === normS(q)));
      if (push) setQuery(["q", "type", "options[prefix]"], new URLSearchParams(q ? { q, type: "product", "options[prefix]": "last" } : {}));
      document.title = (q ? (EN ? `“${q}” – Search` : `„${q}“ – Suche`) : T("Suche", "Search")) + " — REVØRA";
      if (q === cur) return;
      const my = ++sReq;
      let res = [];
      if (q && q === q0 && !push) res = strong(q, hits(d0));
      else if (q) {
        body.classList.add("is-busy");
        try { res = strong(q, hits(await fetchSearch(q))); } catch (e) { res = RV.searchProducts(q); }
        if (my !== sReq) return;
        body.classList.remove("is-busy");
      }
      cur = q;
      paintS(q, res);
    };
    const deb = RV.debounce(() => update(inp.value, true), 260);
    inp.addEventListener("input", deb);
    form.addEventListener("submit", (e) => { e.preventDefault(); update(inp.value, true); inp.blur(); });
    el.querySelector("[data-sx]").addEventListener("click", () => { inp.value = ""; update("", true); inp.focus(); });
    el.querySelectorAll("[data-sg]").forEach((b) => b.addEventListener("click", () => { inp.value = b.dataset.sg; update(b.dataset.sg, true); }));
    offs.push(() => { sReq++; if (lister) lister.destroy(); lister = null; });
    offs.push(onBP(() => paintMini(el)));
    update(q0, false);
    if (!q0 && !MQ_M.matches) setTimeout(() => inp.focus({ preventScroll: true }), 120);
  }
  RV.page("suche", {
    title: (ctx) => ((ctx.query.q || "").trim() ? `„${ctx.query.q.trim()}“ – ${T("Suche", "Search")}` : T("Suche", "Search")) + " — REVØRA",
    header: "solid",
    render: renderSearch,
    destroy: kill,
  });
})();
